export const  engineTypes = [
  {id: 'all', name: 'All'},
  {id: 'direct+drive', name: 'Direct Drive'},
  {id: 'jet+drive', name: 'Jet Drive'},
  {id: 'none', name: 'None'},
  {id: 'other', name: 'Other'},
  {id: 'single+inboard', name: 'Single Inboard'},
  {id: 'single+i--o', name: 'Single I/O'},
  {id: 'single+outboard', name: 'Single Outboard'},
  {id: 'twin+inboard', name: 'Twin Inboard'},
  {id: 'twin+i--o', name: 'Twin I/O'},
  {id: 'twin+outboard', name: 'Twin Outboard'},
  {id: 'triple+i--o', name: 'Triple I/O'},
  {id: 'triple+outboard', name: 'Triple Outboard'},
  {id: 'v+drive', name: 'V-Drive'},
];

export const engineLegacyTypes = {
  'DIRECT DRIVE': 'direct+drive',
  'JET DRIVE': 'jet+drive',
  'NONE': 'none',
  'OTHER': 'other',
  'SINGLE': 'single+inboard',
  'SINGLE I--O': 'single+i--o',
  'SINGLE OUTBOARD': 'single+outboard',
  'TWIN': 'twin+inboard',
  'TWIN I--O': 'twin+i--o',
  'TWIN OUTBOARD': 'twin+outboard',
  'TRIPLE I--O': 'triple+i--o',
  'TRIPLE OUTBOARD': 'triple+outboard',
  'V-DRIVE': 'v+drive'
};
